import React, { FC, useCallback, useEffect, useMemo, useState } from "react";
import { Template } from "../../types";
import styles from "./styles.module.scss";
import { useAppImage } from "../../hooks/useAppImage";

type Props = {
    template: Template;
    selected?: boolean;
    onClick?: (template: Template) => void;
};

export const TemplateCard: FC<Props> = ({ template, selected, onClick }) => {
    const { getImageUrl } = useAppImage();

    const src = useMemo(() => getImageUrl(template, 300), [getImageUrl, template]);
    const [loaded, setLoaded] = useState(true);

    // reset loader when src changes
    useEffect(() => {
        setLoaded(false);
    }, [src]);

    const _onClick = useCallback(
        (event: React.MouseEvent<HTMLAnchorElement>) => {
            event.preventDefault();
            onClick?.(template);
        },
        [onClick, template]
    );

    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
            className={`${styles.card} ${selected ? styles.selected : ""}`}
            onClick={_onClick}
            aria-busy={!loaded}
        >
            <div className={styles.media}>
                {!loaded && (
                    <div className={styles.loader} aria-hidden="true">
                        <span className={styles.spinner} />
                    </div>
                )}

                <img
                    src={src}
                    alt={template ?? "Template"}
                    loading="lazy"
                    onLoad={() => {
                        setTimeout(()=>{
                            setLoaded(true)
                        })
                    }}
                    onError={() => {
                        setTimeout(()=>{
                            setLoaded(true)
                        })
                    }} // stop spinner even if it fails
                    className={`${styles.image} ${loaded ? styles.imageVisible : styles.imageHidden}`}
                    draggable={false}
                    onDragStart={(e) => e.preventDefault()}
                    onContextMenu={(e) => e.preventDefault()}
                />
            </div>
        </a>
    );
};
